var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___RVdral",
  "h_": "KeyboardModeIntroModal.module__description___RVdral",
  "Xq": "KeyboardModeIntroModal.module__tips___RVdral",
  "uN": "KeyboardModeIntroModal.module__tip___RVdral",
  "HP": "KeyboardModeIntroModal.module__keys___RVdral",
  "eS": "KeyboardModeIntroModal.module__kbd___RVdral",
  "me": "KeyboardModeIntroModal.module__separator___RVdral",
  "xY": "KeyboardModeIntroModal.module__tipText___RVdral",
};

module.exports = exports;
